import React from 'react';
import { Box, Toolbar } from '@mui/material';

interface MainContentProps {
  children: React.ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        width: { sm: `calc(100% - 240px)` }, // 240px is the sidebar width
        px: { xs: 0, sm: 3 },
        py: { xs: 1, sm: 3 },
        height: '100dvh',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Toolbar />
      {children}
    </Box>
  );
};

export default MainContent;